export const getRedirectUrl = (param) => {
  const isLocalhost = window.location.hostname === 'localhost';
  const isDev = window.location.hostname.includes('dev');
  const redirectUri = `${
    isLocalhost
      ? 'http://localhost:3001'
      : isDev
      ? 'https://dev.marketchef.ai'
      : 'https://marketchef.ai'
  }`;

  if (param) {
    return `${redirectUri}/${param}`;
  }
  return redirectUri;
};

export const validateURL = (url) => {
  const originalUrl = url.toLowerCase();
  const urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i;
  const isValid = urlRegex.test(url);

  if (!isValid) {
    return { isValid: false, url: originalUrl };
  }

  // If no protocol, add https://
  if (!originalUrl.startsWith('http://') && !originalUrl.startsWith('https://')) {
    return { isValid: true, url: 'https://' + originalUrl };
  }

  return { isValid: true, url: originalUrl };
};
